import colors from 'vuetify/es5/util/colors'
var themes = {
  light: {
    primary: '#0F8A97',
    secondary: colors.grey.darken2,
    accent: '#174696',
    error: '#d77363',
    info: '#2ec1d1',
    success: '#64c99b',
    warning: '#E39900'
  },
  dark: {
    primary: colors.blue.darken2,
    secondary: colors.grey.lighten2,
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  }
}

export default {
  dark: false,
  options: {
    customProperties: true
  },
  themes: themes
}
